export interface Endpoint {
  url: string;
  includeOrganizationSubscription: boolean;
  routeParams?: Array<number | string>;
  queryParams?: string;
}

class Endpoints {
  endpointsMap: Map<string, Endpoint>;

  constructor() {
    this.endpointsMap = new Map<string, Endpoint>();
    this.endpointsMap.set("organization", {
      url: "/organization",
      includeOrganizationSubscription: true,
    });
    this.endpointsMap.set("organization_subscription_key", {
      url: "/organization/subscription-key",
      includeOrganizationSubscription: false,
    });
    this.endpointsMap.set("organization_gis_coordinates", {
      url: "/organization/gis-coordinates",
      includeOrganizationSubscription: true,
    });
    this.endpointsMap.set("request_organization", {
      url: "/organization/request-organization",
      includeOrganizationSubscription: true,
    });
    this.endpointsMap.set("request_delete_organization", {
      url: "/organization/{0}/request-delete-organization",
      includeOrganizationSubscription: true,
    });
    this.endpointsMap.set("subscription_plan_usage", {
      url: "/organization/plan-usage",
      includeOrganizationSubscription: true,
    });
    this.endpointsMap.set("remaining_storage", {
      url: "/organization/remaining-storage",
      includeOrganizationSubscription: true,
    });
    this.endpointsMap.set("custom_project_property", {
      url: "/customprojectproperty",
      includeOrganizationSubscription: true,
    });
    this.endpointsMap.set("custom_project_single_property", {
      url: "/customprojectproperty/{0}",
      includeOrganizationSubscription: true,
    });

    this.endpointsMap.set("custom_project_property_positions", {
      url: "/customprojectproperty/positions",
      includeOrganizationSubscription: true,
    });

    this.endpointsMap.set("damages", {
      url: "/damages",
      includeOrganizationSubscription: true,
    });
    this.endpointsMap.set("damages_all", {
      url: "/damages/all",
      includeOrganizationSubscription: true,
    });
    this.endpointsMap.set("damage", {
      url: "/damages/{0}",
      includeOrganizationSubscription: true,
    });
    this.endpointsMap.set("damage_file", {
      url: "/damages/{0}/file",
      includeOrganizationSubscription: true,
    });
    this.endpointsMap.set("damages_metadata", {
      url: "/damages/metadata",
      includeOrganizationSubscription: true,
    });
    this.endpointsMap.set("damages_group_codes", {
      url: "/damages/groupcodes",
      includeOrganizationSubscription: true,
    });
    this.endpointsMap.set("damages_main_codes", {
      url: "/damages/maincodes",
      includeOrganizationSubscription: true,
    });
    this.endpointsMap.set("damages_c2_codes", {
      url: "/damages/c2codes",
      includeOrganizationSubscription: true,
    });
    this.endpointsMap.set("damages_details_for_codes", {
      url: "/damages/details-for-codes",
      includeOrganizationSubscription: true,
    });
    this.endpointsMap.set("feature_flags", {
      url: "/feature-flags",
      includeOrganizationSubscription: true,
    });
    this.endpointsMap.set("accepted_file_types", {
      url: "/files/accepted-file-types",
      includeOrganizationSubscription: true,
    });
    this.endpointsMap.set("files_download", {
      url: "/files/download-zip",
      includeOrganizationSubscription: true,
    });
    this.endpointsMap.set("file_download", {
      url: "/files/{0}/download",
      includeOrganizationSubscription: true,
    });
    this.endpointsMap.set("gis_coordinates", {
      url: "/gis-coordinates",
      includeOrganizationSubscription: true,
    });
    this.endpointsMap.set("inspections", {
      url: "/inspections",
      includeOrganizationSubscription: true,
    });
    this.endpointsMap.set("inspections_all", {
      url: "/inspections/all",
      includeOrganizationSubscription: true,
    });
    this.endpointsMap.set("inspections_update_comparison", {
      url: "/projects/{0}/update-inspection-comparison",
      includeOrganizationSubscription: true,
    });
    this.endpointsMap.set("inspections_update_comparison_async", {
      url: "/projects/{0}/update-inspection-comparison-async",
      includeOrganizationSubscription: true,
    });
    this.endpointsMap.set("inspection", {
      url: "/inspections/{0}",
      includeOrganizationSubscription: true,
    });
    this.endpointsMap.set("inspection_lock", {
      url: "/inspections/{0}/lock",
      includeOrganizationSubscription: true,
    });
    this.endpointsMap.set("inspection_report", {
      url: "/inspections/{0}/report",
      includeOrganizationSubscription: true,
    });
    this.endpointsMap.set("inspection_media_files", {
      url: "/inspections/{0}/mediafiles",
      includeOrganizationSubscription: true,
    });
    this.endpointsMap.set("inspection_media_files_all", {
      url: "/inspections/{0}/mediafiles/all",
      includeOrganizationSubscription: true,
    });
    this.endpointsMap.set("upload_inspection_media_file", {
      url: "/inspections/{0}/uploadmediafile/{1}",
      includeOrganizationSubscription: true,
    });
    this.endpointsMap.set("upload_inspection_media_files", {
      url: "/inspections/{0}/uploadmediafile",
      includeOrganizationSubscription: true,
    });
    this.endpointsMap.set("inspection_mark_relevant", {
      url: "/inspections/{0}/mark-relevant",
      includeOrganizationSubscription: true,
    });
    this.endpointsMap.set("inspection_mark_others_relevant", {
      url: "/inspections/{0}/mark-others-relevant",
      includeOrganizationSubscription: true,
    });
    this.endpointsMap.set("inspection_mark_outdated", {
      url: "/inspections/{0}/mark-outdated",
      includeOrganizationSubscription: true,
    });
    this.endpointsMap.set("verify_inspection_can_be_marked_outdated", {
      url: "/inspections/{0}/verify-inspection-can-be-marked-outdated",
      includeOrganizationSubscription: true,
    });
    this.endpointsMap.set("verify_inspection_can_be_deleted", {
      url: "/inspections/{0}/verify-inspection-can-be-deleted",
      includeOrganizationSubscription: true,
    });
    this.endpointsMap.set("verify_files_can_be_deleted", {
      url: "/inspections/{0}/verify-files-can-be-deleted",
      includeOrganizationSubscription: true,
    });
    this.endpointsMap.set("verify_inspections_can_be_deleted", {
      url: "/inspections/verify-inspections-can-be-deleted",
      includeOrganizationSubscription: true,
    });
    this.endpointsMap.set("jobs", {
      url: "/jobs",
      includeOrganizationSubscription: true,
    });
    this.endpointsMap.set("jobs_all", {
      url: "/jobs/all",
      includeOrganizationSubscription: true,
    });
    this.endpointsMap.set("job", {
      url: "/jobs/{0}",
      includeOrganizationSubscription: true,
    });
    this.endpointsMap.set("job_sewer_objects", {
      url: "/jobs/{0}/sewer-objects",
      includeOrganizationSubscription: true,
    });
    this.endpointsMap.set("job_sewer_objects_all", {
      url: "/jobs/{0}/sewer-objects/all",
      includeOrganizationSubscription: true,
    });
    this.endpointsMap.set("user_job", {
      url: "/jobs/take-job/{0}",
      includeOrganizationSubscription: true,
    });
    this.endpointsMap.set("media_files_video_analysis_job", {
      url: "/mediafiles/videoanalysisjob",
      includeOrganizationSubscription: true,
    });
    this.endpointsMap.set("media_file_video_conversion", {
      url: "/mediafiles/videoconversion/{0}",
      includeOrganizationSubscription: true,
    });
    this.endpointsMap.set("video_analysis_data", {
      url: "/mediafiles/{0}/va-data",
      includeOrganizationSubscription: true,
    });
    this.endpointsMap.set("media_file_video_analysis", {
      url: "/mediafiles/videoanalysis/{0}",
      includeOrganizationSubscription: true,
    });
    this.endpointsMap.set("media_file_analysis_export", {
      url: "/mediafiles/videoanalysis/export/{0}",
      includeOrganizationSubscription: true,
    });
    this.endpointsMap.set("media_file_segmentation", {
      url: "/mediafiles/videoSegmentation/{0}",
      includeOrganizationSubscription: true,
    });
    this.endpointsMap.set("media_file_screenshot", {
      url: "/mediafiles/screenshot/{0}/{1}",
      includeOrganizationSubscription: true,
    });
    this.endpointsMap.set("permissions", {
      url: "/permissions",
      includeOrganizationSubscription: true,
    });
    this.endpointsMap.set("projects", {
      url: "/projects",
      includeOrganizationSubscription: true,
    });
    this.endpointsMap.set("projects_all", {
      url: "/projects/all",
      includeOrganizationSubscription: true,
    });
    this.endpointsMap.set("projects_summary", {
      url: "/projects/summary",
      includeOrganizationSubscription: true,
    });
    this.endpointsMap.set("projects_formats", {
      url: "/projects/formats",
      includeOrganizationSubscription: true,
    });
    this.endpointsMap.set("projects_code_systems", {
      url: "/projects/code-systems",
      includeOrganizationSubscription: true,
    });
    this.endpointsMap.set("project", {
      url: "/projects/{0}",
      includeOrganizationSubscription: true,
    });
    this.endpointsMap.set("project_sewer_objects_all", {
      url: "/projects/{0}/sewer-objects/all",
      includeOrganizationSubscription: true,
    });
    this.endpointsMap.set("project_sewer_objects_ids_all", {
      url: "/projects/{0}/sewer-objects-ids/all",
      includeOrganizationSubscription: true,
    });
    this.endpointsMap.set("project_jobs", {
      url: "/projects/{0}/jobs/all",
      includeOrganizationSubscription: true,
    });
    this.endpointsMap.set("project_team_members_all", {
      url: "/projects/{0}/team-members/all",
      includeOrganizationSubscription: true,
    });
    this.endpointsMap.set("project_inspections_all", {
      url: "/projects/{0}/inspections/all",
      includeOrganizationSubscription: true,
    });
    this.endpointsMap.set("project_inspection_ids_all", {
      url: "/projects/{0}/inspection-ids/all",
      includeOrganizationSubscription: true,
    });
    this.endpointsMap.set("users_available_to_join_project_team", {
      url: "/projects/{0}/users",
      includeOrganizationSubscription: true,
    });
    this.endpointsMap.set("project_media_files", {
      url: "/projects/{0}/files/{1}/mediafiles",
      includeOrganizationSubscription: true,
    });
    this.endpointsMap.set("project_media_file", {
      url: "/projects/{0}/mediafiles/{1}",
      includeOrganizationSubscription: true,
    });
    this.endpointsMap.set("upload_files_in_project", {
      url: "/projects/{0}/files",
      includeOrganizationSubscription: true,
    });
    this.endpointsMap.set("upload_files_in_project_async", {
      url: "/projects/{0}/files-async",
      includeOrganizationSubscription: true,
    });
    this.endpointsMap.set("sewer_objects", {
      url: "/sewer-objects",
      includeOrganizationSubscription: true,
    });
    this.endpointsMap.set("section", {
      url: "/sections/{0}",
      includeOrganizationSubscription: true,
    });
    this.endpointsMap.set("node", {
      url: "/nodes/{0}",
      includeOrganizationSubscription: true,
    });
    this.endpointsMap.set("structure", {
      url: "/structures/{0}",
      includeOrganizationSubscription: true,
    });
    this.endpointsMap.set("sewer_objects_summary", {
      url: "/sewer-objects/summary/all",
      includeOrganizationSubscription: true,
    });
    this.endpointsMap.set("sewer_objects_map", {
      url: "/sewer-objects/map",
      includeOrganizationSubscription: true,
    });
    this.endpointsMap.set("azure_maps_token", {
      url: "/sewer-objects/azure-maps-token",
      includeOrganizationSubscription: true,
    });
    this.endpointsMap.set("sewer_objects_export", {
      url: "/sewer-objects/export",
      includeOrganizationSubscription: true,
    });
    this.endpointsMap.set("linked_sewer_objects_all", {
      url: "/sewer-objects/{0}/linked-objects/all",
      includeOrganizationSubscription: true,
    });
    this.endpointsMap.set("users", {
      url: "/users",
      includeOrganizationSubscription: true,
    });
    this.endpointsMap.set("close_user_account", {
      url: "/users/close-account",
      includeOrganizationSubscription: true,
    });
    this.endpointsMap.set("users_all", {
      url: "/users/all",
      includeOrganizationSubscription: true,
    });
    this.endpointsMap.set("user", {
      url: "/users/{0}",
      includeOrganizationSubscription: true,
    });
    this.endpointsMap.set("user_image", {
      url: "/users/{0}/file",
      includeOrganizationSubscription: true,
    });
    this.endpointsMap.set("user_profile", {
      url: "/users/my-profile",
      includeOrganizationSubscription: true,
    });
    this.endpointsMap.set("users_summary", {
      url: "/users/summary",
      includeOrganizationSubscription: true,
    });
    this.endpointsMap.set("users_roles", {
      url: "/users/roles",
      includeOrganizationSubscription: true,
    });
    this.endpointsMap.set("users_removed_all", {
      url: "/users/removed-users/all",
      includeOrganizationSubscription: true,
    });
    this.endpointsMap.set("users_current", {
      url: "/users/current-user",
      includeOrganizationSubscription: false,
    });
    this.endpointsMap.set("user_organizations", {
      url: "/users/organizations/all",
      includeOrganizationSubscription: true,
    });
    this.endpointsMap.set("user_organization_requests", {
      url: "/users/organization-requests/all",
      includeOrganizationSubscription: true,
    });
    this.endpointsMap.set("employment_statuses", {
      url: "/users/employment-statuses",
      includeOrganizationSubscription: true,
    });
    this.endpointsMap.set("invite_user", {
      url: "/users/invite-user",
      includeOrganizationSubscription: true,
    });
    this.endpointsMap.set("collaboration_invitations", {
      url: "/users/collaboration-invitations/all",
      includeOrganizationSubscription: true,
    });
    this.endpointsMap.set("last_accessed_organization", {
      url: "/users/last-accessed-organization",
      includeOrganizationSubscription: false,
    });
    this.endpointsMap.set("video_analysis_usage_per_user", {
      url: "/users/{0}/video-analysis-usage",
      includeOrganizationSubscription: false,
    });
    this.endpointsMap.set("collaboration-status", {
      url: "/organizationrequests/collaboration-status/{0}",
      includeOrganizationSubscription: true,
    });
    this.endpointsMap.set("remove_from_organization", {
      url: "/users/remove-from-organization/{0}",
      includeOrganizationSubscription: true,
    });
    this.endpointsMap.set("zendesk_users", {
      url: "/zendesk-users",
      includeOrganizationSubscription: true,
    });
    this.endpointsMap.set("subscription_plans", {
      url: "/subscription-plans",
      includeOrganizationSubscription: true,
    });
    this.endpointsMap.set("subscription_checkout_session", {
      url: "/subscription-plans/create-checkout-session",
      includeOrganizationSubscription: true,
    });
    this.endpointsMap.set("active_subscription_plan", {
      url: "/subscription-plans/active-subscription-plan",
      includeOrganizationSubscription: true,
    });
    this.endpointsMap.set("customer_portal_session", {
      url: "/subscription-plans/customer-portal-session",
      includeOrganizationSubscription: true,
    });
    this.endpointsMap.set("available_countries", {
      url: "/address/available-countries",
      includeOrganizationSubscription: false,
    });
    this.endpointsMap.set("organization_subscription_update", {
      url: "/organization/subscription",
      includeOrganizationSubscription: true,
    });
    this.endpointsMap.set("organization_subscription_downgrade", {
      url: "/organization/downgrade-subscription",
      includeOrganizationSubscription: true,
    });
    this.endpointsMap.set("organization_subscription_update_is_valid", {
      url: "/organization/subscription-plan-update-valid",
      includeOrganizationSubscription: true,
    });
    this.endpointsMap.set("locked_inpsections_count", {
      url: "/users/locked-inspections-count",
      includeOrganizationSubscription: true,
    });
    this.endpointsMap.set("organization_va_calls_usage", {
      url: "/organization/video-analysis-calls-usage",
      includeOrganizationSubscription: true,
    });
    this.endpointsMap.set("extra_va_unit_price", {
      url: "/subscription-plans/extra-va-unit-price",
      includeOrganizationSubscription: false,
    });
    this.endpointsMap.set("organization_subscription_downgrade_update", {
      url: "/organization/scheduled-subscription",
      includeOrganizationSubscription: true,
    });
    this.endpointsMap.set("organization_subscription_plan_is_valid", {
      url: "/organization/subscription-plan-is-valid",
      includeOrganizationSubscription: true,
    });
    this.endpointsMap.set("organization_subscription_upgrade", {
      url: "/organization/upgrade-subscription",
      includeOrganizationSubscription: true,
    });
    this.endpointsMap.set("organization_subscription_cancel_downgrade", {
      url: "/organization/cancel-downgrade-request",
      includeOrganizationSubscription: true,
    });
    this.endpointsMap.set("organization_subscription_cancel", {
      url: "/organization/cancel-paid-plan",
      includeOrganizationSubscription: true,
    });
    this.endpointsMap.set("withdraw_subscription_cancelation_request", {
      url: "/organization/withdraw-cancel-request",
      includeOrganizationSubscription: true,
    });
    this.endpointsMap.set("deleted_data", {
      url: "/organization/soft-deleted-data",
      includeOrganizationSubscription: true,
    });
    this.endpointsMap.set("download_default_template", {
      url: "/report-templates/{0}/download-default-template/{1}",
      includeOrganizationSubscription: true,
    });
    this.endpointsMap.set("upload_report_template", {
      url: "/report-templates/upload",
      includeOrganizationSubscription: true,
    });
    this.endpointsMap.set("get_report_templates_all", {
      url: "/report-templates/all",
      includeOrganizationSubscription: true,
    });
    this.endpointsMap.set("report_templates_delete", {
      url: "/report-templates",
      includeOrganizationSubscription: true,
    });
    this.endpointsMap.set("report_template_download", {
      url: "/report-templates/{0}/download",
      includeOrganizationSubscription: true,
    });
    this.endpointsMap.set("report_templates_download_zip", {
      url: "/report-templates/download-zip",
      includeOrganizationSubscription: true,
    });
    this.endpointsMap.set("get_subscription_coupon", {
      url: "/organization/subscription-coupon",
      includeOrganizationSubscription: true,
    });
    this.endpointsMap.set("promotion", {
      url: "/organization/promotion",
      includeOrganizationSubscription: true,
    });
    this.endpointsMap.set("organization_statuses", {
      url: "/organization/organization-statuses",
      includeOrganizationSubscription: true,
    });
    this.endpointsMap.set("restore_deleted_data", {
      url: "/organization/restore-deleted-data",
      includeOrganizationSubscription: true,
    });
    this.endpointsMap.set("hard_delete_data", {
      url: "/organization/hard-delete-data",
      includeOrganizationSubscription: true,
    });
    this.endpointsMap.set("translations", {
      url: "/translations",
      includeOrganizationSubscription: false,
    });
    this.endpointsMap.set("get_address_suggestions", {
      url: "/address/get-suggestions",
      includeOrganizationSubscription: false,
    });
    this.endpointsMap.set("file-id", {
      url: "/mediaFiles/file-id/{0}",
      includeOrganizationSubscription: true,
    });
    this.endpointsMap.set("file-guid", {
      url: "/mediaFiles/file-guid/{0}",
      includeOrganizationSubscription: true,
    });
    this.endpointsMap.set("summarize_batch_analysis", {
      url: "/mediaFiles/summarize-batch-analysis",
      includeOrganizationSubscription: true,
    });
    this.endpointsMap.set("trigger_batch_analysis", {
      url: "/mediaFiles/trigger-batch-analysis",
      includeOrganizationSubscription: true,
    });
    this.endpointsMap.set("summarize_batch_highlight_detection", {
      url: "/mediaFiles/summarize-batch-segmentation",
      includeOrganizationSubscription: true,
    });
    this.endpointsMap.set("trigger_batch_highlight_detection", {
      url: "/mediaFiles/trigger-batch-segmentation",
      includeOrganizationSubscription: true,
    });
    this.endpointsMap.set("analysis_confidence", {
      url: "/analysis-confidence",
      includeOrganizationSubscription: true,
    });
    this.endpointsMap.set("mediafiles", {
      url: "/mediafiles",
      includeOrganizationSubscription: false
    });
    this.endpointsMap.set("get_video_conversion_sas", {
      url: "/mediafiles/videoconversion/export/{0}",
      includeOrganizationSubscription: false
    });
    this.endpointsMap.set("get_prices", {
      url: "/shop/prices",
      includeOrganizationSubscription: true
    });
    this.endpointsMap.set("get_activity_prices", {
      url: "/shop/activity-prices",
      includeOrganizationSubscription: true
    });
    this.endpointsMap.set("create_shop_checkout_session", {
      url: "/shop/create-checkout-session",
      includeOrganizationSubscription: true
    });
    this.endpointsMap.set("current_user_balance", {
      url: "/shop/credit-balance",
      includeOrganizationSubscription: true
    });
    this.endpointsMap.set("validate_user_balance", {
      url: "/shop/validate-balance",
      includeOrganizationSubscription: true
    });
    this.endpointsMap.set("shop_history", {
      url: "/shop/history",
      includeOrganizationSubscription: true
    });
    this.endpointsMap.set("shop_orders", {
      url: "/shop/customer-portal-session",
      includeOrganizationSubscription: true
    });
    this.endpointsMap.set("media_file_ocr", {
      url: "/mediafiles/ocr/{0}",
      includeOrganizationSubscription: true
    }),
    this.endpointsMap.set("media_file_ocr_export", {
      url: "/mediafiles/ocr/export/{0}",
      includeOrganizationSubscription: true
    }),
    this.endpointsMap.set("media_file_ocr_export_isybau", {
      url: "/mediafiles/ocr/export-ISYBAU_2017-07/{0}",
      includeOrganizationSubscription: true
    }),
    this.endpointsMap.set("media_file_ocr_export_dwa", {
      url: "/mediafiles/ocr/export-dwa-m150_04-2010/{0}",
      includeOrganizationSubscription: true
    }),
    this.endpointsMap.set("get_main_code_colors", {
      url: "/mc-colors",
      includeOrganizationSubscription: true
    })
  }

  get(key: string): Endpoint {
    const endpoint = this.endpointsMap.get(key);
    if (!endpoint) throw new Error(`Endpoint for key ${key} does not exist`);

    return {
      url: endpoint.url,
      includeOrganizationSubscription: endpoint.includeOrganizationSubscription,
    };
  }
}

export const endpoints = new Endpoints();
